import { ICommunityNumber, IPlanElevation } from 'src/types/plan.interface'

export const getRegionFromDivision = (
  regionToDivision: Record<string, Array<string>>,
  regions: Record<string, string>,
  division: string
) => {
  const regionValue = Object.keys(regionToDivision).find((key) =>
    regionToDivision[key].includes(division?.toUpperCase())
  )
  const regionKey = Object.keys(regions).find(
    (key) => regions[key] === regionValue
  )
  return regionKey || ''
}

export const getCorePlanCommunityPlanId = (
  region: string,
  plan: string,
  planElev: IPlanElevation,
  regions: Record<string, string>
) => {
  const regionKey =
    Object.keys(regions).find((key) => regions[key] === region) || region
  return `${regionKey?.toLowerCase()}${plan?.toUpperCase()}${planElev.value?.toUpperCase()}`
}

export const getPlanCommunityPlanId = (
  community: ICommunityNumber,
  plan: string,
  planElev: IPlanElevation
) => {
  return `${
    community.cNumberVal
  }${plan?.toUpperCase()}${planElev.value?.toUpperCase()}`
}

export const getHighValuePlanCommunityPlanId = (
  divisionCode: string,
  plan: string,
  planElev: IPlanElevation
) => {
  return `${divisionCode.toUpperCase()}${plan?.toUpperCase()}${planElev.value?.toUpperCase()}`
}
